import { IStorageProvider } from './storage-model';

export class SessionStorage implements IStorageProvider {
  private storageKeyPrefixName: string;

  constructor(storageKeyPrefixName?) {
    this.storageKeyPrefixName = storageKeyPrefixName ? storageKeyPrefixName + '_' : '';
  }
  get(key: string): string {
    return sessionStorage.getItem(this.storageKeyPrefixName + key) as string;
  }
  remove(key: string): void {
    localStorage.removeItem(this.storageKeyPrefixName + key);
  }
  set(key: string, value: string): void {
    sessionStorage.setItem(this.storageKeyPrefixName + key, value);
  }
  clear(): void {
    sessionStorage.clear();
  }
}
